<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="2" md="2" class="pl-3">
                <v-avatar
                variant="outlined"
                  :image="srcMethodProfile(user.profilePhoto)"
                  size="60"
                ></v-avatar>
              </v-col>
              <v-col cols="10" md="10" class="mt-3 pl-4">
                <h2>{{ user.profileName}}</h2></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>Phone : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.phone}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>Email : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.email}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>NRC : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.nrcNo}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>License : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.license}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>Address : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.address}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>Remark : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.remark}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="12" >
        <v-row no-gutters class="pa-1">
              <v-col cols="3" md="3" class="pl-3">
                <h5>Date : </h5>
              </v-col>
              <v-col cols="9" md="9" >
                <h5>{{ user.date}}</h5></v-col>
            </v-row>
            <v-divider></v-divider>
            </v-col>


        </v-row>
</template>
<script>
import userService from "../service/UserAccountService";
import axios from "../config";
export default {
  data: () => ({
    user:{},
    friendId:0,
  }),
   props: {customerId:Number},
  mounted: function() {
    this.friendId = this.$store.state.friend.userAccountId;
    if(this.friendId!=undefined){
      this.getUserDetail();
    }
    
  },
  methods: {
    srcMethodProfile: function (pictureCode) {
      if (pictureCode == undefined) {
        return `/info/logo.png`;
      } else {
        return `${axios.defaults.baseURL}/userphoto/${pictureCode}.png`;
      }
    },
    getUserDetail: function () {
      let friendId = this.customerId;
      if(this.customerId==0){
        friendId = this.friendId;
      }
      userService
        .getUserDetailList(friendId)
        .then((response) => {
          this.user = Object.assign({},response);
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
  },
  watch: {
    customerId(){
        this.getUserDetail();
    }
  },
  components: {}
};
</script>
<style scoped>

</style>